export const formConstants = {
  FORMS_GETALL_INIT: 'FORMS_GETALL_INIT',
  FORMS_GETALL_REQUEST: 'FORMS_GETALL_REQUEST',
  FORMS_GETALL_SUCCESS: 'FORMS_GETALL_SUCCESS',

  FORMS_RETRIEVE_INIT: 'FORMS_RETRIEVE_INIT',
  FORMS_RETRIEVE_SUCCESS: 'FORMS_RETRIEVE_SUCCESS',
  FORMS_RETRIEVE_REQUEST: 'FORMS_RETRIEVE_REQUEST',
  FORMS_RETRIEVE_FAILURE: 'FORMS_RETRIEVE_FAILURE'
}